import Service from "./Service";
const baseurl = '/api/historia-opcion-aiepi';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    showByItem(id) {
        return Service.get(`${baseurl}/show-by-item/${id}`);
    },
}